<template>
    <page>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-expansion-panels v-model="panel1" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div>
                                    <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card>
                                    <v-card-text>
                                        <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom"
                                                :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                                                :error-messages="errors.collect('form.tranDateFrom')"
                                                v-validate="'required'" />
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                            <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo"
                                                :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                                                :error-messages="errors.collect('form.tranDateTo')"
                                                v-validate="'required'" />
                                            </v-flex>
                                        </v-layout>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.billingAcct" :label="labels.billingAcct" :error-messages="errors.collect('form.billingAcct')" :data-vv-as="labels.billingAcct" v-validate="'required'"
                                            data-vv-name="form.billingAcct" append-icon="mdi-magnify" @click:append="getHelpList('billingAcct')" readonly/>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.financialIns" :label="labels.financialIns" :error-messages="errors.collect('form.financialIns')" :data-vv-as="labels.financialIns" v-validate="'required'"
                                            data-vv-name="form.financialIns" append-icon="mdi-magnify" @click:append="getHelpList('financialIns')" readonly/>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType" v-validate="'required'"
                                            data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="multiPolTypeList = true" readonly/>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.scheme" :label="labels.scheme" :error-messages="errors.collect('form.scheme')" :data-vv-as="labels.scheme" v-validate="'required'"
                                            data-vv-name="form.scheme" append-icon="mdi-magnify" @click:append="multiSchemeList = true" readonly/>
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-checkbox
                      :label="labels.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="labels.pbPrtParam"
                    />
                  </v-flex>
            <v-layout row wrap>
              <v-flex lg6 xs12>
              <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                <v-icon left dark>mdi-file-export</v-icon>
                {{labels.export}}
              </v-btn>
              <v-btn-toggle dense mandatory v-model="form.format">
                <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                  <span>{{format.label}}</span>
                  <v-icon :color="format.color">{{format.icon}}</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="multiPolTypeList" width="900px" persistent>
          <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
        </v-dialog>
        <v-dialog v-model="multiSchemeList" width="900px" persistent>
          <multi-scheme-help-list :scheme="form.scheme" @close="doClose" @doAssign="doAssignScheme($event)"></multi-scheme-help-list>
        </v-dialog>
        <v-dialog v-model="multiInterList1" width="900px" persistent>
          <multi-intermediary-help-list
            :intr="form.financialIns"
            intrGrp="AG"
            helpListTitle="Billing Accounts HelpList"
            @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
        </v-dialog>
        <v-dialog v-model="multiInterList2" width="900px" persistent>
          <multi-intermediary-help-list
            :intr="form.financialIns"
            intrGrp="12"
            helpListTitle="Financial Institutions HelpList"
            @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
        </v-dialog>
    </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiSchemeHelpList from '@/components/core/common/dialog/MultiSchemeHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
export default {
  data() {
    return {
      menu: {},
      form: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        billingAcct: 'All',
        financialIns: 'All',
        polType: 'All',
        pbPrtParam: true,
        scheme: '202',
        format: undefined
      },
      labels: {
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        billingAcct: 'Billing Account(s)',
        financialIns: 'Financial Institution(s)',
        polType: 'Policy Type(s)',
        pbPrtParam: 'Print Runtime Parameters',
        scheme: 'Scheme(s)',
        export: 'Export to',
        format: 'Export Format'
      },
      panel1: [0],
      // HelpList
      multiPolTypeList: false,
      multiSchemeList: false,
      multiInterList1: false,
      multiInterList2: false,
      billAcctNoList: [],
      isPermitted100: true,
      isPermitted200: true,
      intrGrp: undefined,
      supportedFormat: [],
      loading: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initAutoBatchRenewalUppListing
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(field) {
      switch (field) {
        case 'billingAcct':
          this.intrGrp = 'AG'
          this.multiInterList1 = true
          break
        case 'financialIns':
          this.intrGrp = '12'
          this.multiInterList2 = true
          break
      }
    },
    doAssignPolType(Obj) {
      this.form.polType = []
      this.form.polType = Obj.finalSelectedItems.toString()
    },
    async doAssignScheme(Obj) {
      this.form.scheme = []
      this.form.scheme = Obj.finalSelectedItems.toString()
    },
    async doAssignInter(Obj) {
      switch (this.intrGrp) {
        case 'AG':
          this.form.billingAcct = []
          this.form.billingAcct = Obj.finalSelectedItems.toString()
          break
        case '12':
          this.form.financialIns = []
          this.form.financialIns = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.multiPolTypeList = false
      this.multiSchemeList = false
      this.multiInterList1 = false
      this.multiInterList2 = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  components: {
    MultiPolTypeHelpList,
    MultiSchemeHelpList,
    MultiIntermediaryHelpList
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ]
}
</script>
